import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(
  (theme) => ({
    upperGrid: {},
    belowGrid: {},
    secondColumn: {},
    half: {},
    card: {
      border: '1px solid rgba(196, 196, 196, 0.5);',
      borderRadius: '20px',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.01)',
      marginTop: theme.spacing(1),
    },
    relative: {
      position: 'relative',
    },
    arrow: {
      position: 'absolute',
      transform: 'translateX(-85%)',
    },
    divider: {
      backgroundColor: 'rgba(196, 196, 196, 0.5)',
      marginTop: theme.spacing(1),
    },
    mt: {
      marginTop: theme.spacing(2),
    },
    [theme.breakpoints.up('lg')]: {
      belowGrid: {
        position: 'relative',
        '&:after': {
          content: '""',
          background: 'rgba(196, 196, 196, 0.5)',
          position: 'absolute',
          top: '-10%',
          right: 0,
          height: '110%',
          width: '1px',
        },
      },
      upperGrid: {
        position: 'relative',
        '&:after': {
          content: '""',
          background: 'rgba(196, 196, 196, 0.5)',
          position: 'absolute',
          top: '25%',
          right: 0,
          height: '50%',
          width: '1px',
        },
      },
      secondColumn: {
        paddingLeft: theme.spacing(2),
      },
      half: {
        width: '50%',
      },
    },
  }),
  { name: 'TransactionDetail' }
);

export interface TransactionTransferProps {
  payerName: string | null;
  fundsUID: string | null;
  sourceOfFund?: string | null;
  mid: string;
  merchantBusinessType: string;
  tid: string;
}
